"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * BackEnd FrontEndで利用するtext...
 */
exports.default = Object.freeze({
    ja: {
        view: {
            dictionary: {
                link: {
                    rehaplan_privacy: {
                        link: 'https://rehaplan.jp/service/privacy',
                        title: 'プライバシーポリシー'
                    },
                    policy: {
                        link: 'https://rehaplan.jp/service/policy',
                        title: '利用規約'
                    }
                },
                button_caption: {
                    ok: 'OK',
                    cancel: 'キャンセル',
                    logout: 'ログアウト',
                    yes: 'はい',
                    no: 'いいえ'
                },
            },
            auth: {
                top: {
                    button_caption: {
                        login: 'ログイン',
                        close: '閉じる'
                    },
                    label: {
                        username: 'メールアドレス',
                        password: 'パスワード',
                    },
                    placeholder: {
                        username: 'mail@example.com',
                        password: '　'
                    }
                },
                sign_up: {
                    button_caption: {
                        sign_up: '上記内容で登録する'
                    },
                    label: {
                        username: 'メールアドレス',
                        password: 'パスワード',
                        password_confirm: 'パスワード(再確認)',
                        office_id: '事業所番号',
                        rehaplan_user_id: 'リハプランUSER ID'
                    },
                    placeholder: {
                        username: 'mail@example.com',
                        password: '　',
                        password_confirm: '　',
                        office_id: '　',
                        rehaplan_user_id: '　'
                    },
                },
                verify: {
                    messages: {
                        title: '入力頂いたメールアドレスに6桁の認証コードを送信しています。<br>メールを確認して認証コードを入力してください。'
                    },
                    button_caption: {
                        verify: '認証コードを送信'
                    },
                    label: {
                        title: '認証コードの入力',
                        username: 'メールアドレス',
                        code: '認証コード',
                    },
                    placeholder: {
                        username: 'mail@example.com',
                        code: ' ',
                    },
                }
            },
            host: {
                top: {
                    tabs: {
                        standard: '通常のご利用',
                        reserved: '定期的なご利用'
                    },
                    button_caption: {
                        create_new_room: '部屋番号を発行する',
                        update_settings: '設定する',
                        start_rehab_online_short: '開始する',
                        add_new_row: '追加',
                        clear: 'クリア',
                        start_rehab_online: 'オンライン会話を開始する',
                        setup_client_procedure1: "利用者用タブレットの",
                        setup_client_procedure2: "初期設定はこちら"
                    },
                    messages: {
                        first_confirm: [
                            {
                                top: '① お相手の準備が整っていることをご確認ください',
                                details: [
                                    '・タブレットの電源をつけて、パスコードを入力',
                                    '・リハブスタジオのアイコンを押す'
                                ]
                            },
                            {
                                top: '② 電話がつながった状態で、ボタンを押してください',
                                details: []
                            },
                        ],
                        input_room_no: '③お相手のタブレットに部屋番号を入力してもらいましょう',
                        how_to_reserved: [
                            '① 開催する曜日毎に、部屋番号・メモを入力し、設定するボタンを押します',
                            '② 設定した部屋番号を、その回の参加者に周知してください',
                            '③ 開催当日、開始するボタンを押して、オンライン会話を開始しましょう'
                        ],
                        reserved_warning: [
                            '※個人情報の入力はお控えください',
                            '※部屋番号は定期的に変更してください'
                        ],
                        room_duplicate_error: '既に利用されている番号です。変更してください。',
                        update_setting_confirm: '部屋番号を設定しますか？',
                        clear_setting_confirm: '部屋番号・メモを消しますか？',
                    },
                    label: {
                        room_no: '部屋番号'
                    },
                    week: [
                        '月',
                        '火',
                        '水',
                        '木',
                        '金',
                        '土',
                        '日'
                    ],
                    reserved_row: {
                        placeholder: {
                            room_no: '番号4桁',
                            memo: 'メモ\r\n時間/人数等'
                        }
                    }
                },
                room: {
                    button_caption: {
                        exit_room: '通話終了',
                        exit_ok: '通話を終了する',
                        exit_cancel: 'いいえ'
                    },
                    messages: {
                        exit_confirm: '通話を終了しますか？'
                    }
                }
            },
            client: {
                top: {
                    button_caption: {
                        start_rehab_online: 'オンライン通話を開始する',
                        close: '閉じる'
                    },
                    messages: {
                        enter_room_no: '担当者に聞いた部屋番号を入力'
                    }
                },
                room: {
                    button_caption: {
                        exit_room: '通話終了',
                        exit_ok: '通話を終了する',
                        exit_cancel: 'いいえ'
                    },
                    messages: {
                        exit_confirm: '通話を終了しますか？'
                    }
                }
            }
        }
    }
});



//////////////////
// WEBPACK FOOTER
// ./common/src/constrains/locale/texts.ts
// module id = WQ+C
// module chunks = 1